// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"6e3fb00ac214c40bb739","522":"939aabe10bccbf4484d2"}[chunkId] + ".js";
};